import type { CSSProperties } from 'react';

import type {
  TransactionStatus,
  TransactionType,
} from '@/store/expenses-store/transactions/transactions.dto.ts';

export const STATUS_COLORS: Record<TransactionStatus, string> = {
  completed: '#4ADE80',
  pending: '#FCCC50',
  processing: '#FCCC50',
  failed: '#F87171',
  cancelled: '#F87171',
  needs_approval: '#FCCC50',
  waits_for_receiving: '#38BDF8',
};

export const TYPE_COLORS: Record<TransactionType, string> = {
  incoming: '#4ADE80', // green — money in
  outgoing: 'var(--amount-negative)', // red — money out (theme-aware, clears 3:1 both themes)
  refund: '#38BDF8', // blue — money returned
  expenses: 'var(--amount-negative)', // red — money out
};

// incoming money (+): incoming, refund. outgoing money (-): outgoing, expenses.
export const isInflow = (type: TransactionType): boolean =>
  type === 'incoming' || type === 'refund';

export const formatSignedAmount = (amount: number, type: TransactionType): string =>
  `${isInflow(type) ? '+' : '-'} $${amount.toFixed(2)}`;

export const amountStyle = (type: TransactionType): CSSProperties => ({
  color: TYPE_COLORS[type] ?? '#94A3B8',
  fontWeight: 700,
});

export const pillStyle = (background: string): CSSProperties => ({
  background,
  width: 'max-content',
  padding: '4px 8px',
  borderRadius: '8px',
  color: '#0F172A',
});
